import { render, staticRenderFns } from "./editableSpan.vue?vue&type=template&id=899b5822&scoped=true"
import script from "./editableSpan.vue?vue&type=script&lang=js"
export * from "./editableSpan.vue?vue&type=script&lang=js"
import style0 from "./editableSpan.vue?vue&type=style&index=0&id=899b5822&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "899b5822",
  null
  
)

export default component.exports